import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const useGetSessionTrialConfig = ({ trialId, enabled = true }) => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["session_trial_config", trialId],
    queryFn: async () => {
      const res = await axios.get(`${__API_URL__}/api/photos/trials/${trialId}/session-config/`, {
        headers: { Authorization: `Token ${token}` },
      });
      return res.data;
    },
    enabled: enabled && Boolean(trialId),
    refetchOnWindowFocus: false,
  });
};

export default useGetSessionTrialConfig;
